import "../chunk-BUSYA2B4.js";
function isNextFetcher(fetch) {
  return "__nextPatched" in fetch && fetch.__nextPatched === true;
}
export {
  isNextFetcher
};
//# sourceMappingURL=nextFetcher.js.map